module.exports = __webpack_public_path__ + "img/touchpanel.9e047523.jpg";